import React, { ReactElement, useContext, useEffect } from 'react';

import Modal from '../../../../shared/components/modal/Modal';
import { ModalContext } from '../../../../shared/components/modal/ModalContext';
import { ModalContextModel } from '../../../../shared/components/modal/models/modal-context.model';
import useDeleteModal from '../../../../shared/hooks/use-delete-modal/use-delete-modal';
import { WebGameResponseModel } from '../../../models/web-game-response.model';
import { deleteWebGame } from '../../../thunks/delete-web-game.thunk';
import { getWebGamesTotalCount } from '../../../thunks/get-web-games-total-count.thunk';
import { getWebGames } from '../../../thunks/get-web-games.thunk';
import { WebGameHeaderFiltersAndPaginationModel } from '../../../thunks/models/web-game-header-filters-and-pagination.model';
import { WebGamesFiltersModel } from '../../../thunks/models/web-games-filters.model';

export const useShowDeleteGamesModal = (
  ids: number[],
  filters?: WebGameHeaderFiltersAndPaginationModel
): ReactElement => {
  const ctx = useContext(ModalContext) as ModalContextModel;

  const deleteModal = useDeleteModal<
    void,
    number,
    WebGameResponseModel[],
    Partial<WebGameHeaderFiltersAndPaginationModel> | undefined,
    number,
    Partial<WebGamesFiltersModel> | undefined
  >({
    ids: ids,
    deleteAction: deleteWebGame,
    param: filters,
    afterDeleteAction: getWebGames,
    resetTotalCountParams: filters?.header,
    resetTotalCount: getWebGamesTotalCount,
  });

  useEffect(() => {
    if (ids.length && !ctx.isOpen) {
      ctx.componentHandler(deleteModal);
      ctx.modalStateHandler();
    }
  }, [ids]);

  return <Modal>{ctx.component}</Modal>;
};
